import { useEffect, useState } from 'react';
import env from 'react-dotenv';
import { useNavigate } from 'react-router';
import { Header } from '../components/Header';
import map1 from "../assets/images/Map1-1.png";
import map2 from "../assets/images/Map1-2.png";
import map3 from "../assets/images/Map2-1.png";
import map4 from "../assets/images/Map2-2.png";
import map5 from "../assets/images/Map3-1.png";
import map6 from "../assets/images/Map3-2.png";
import map7 from "../assets/images/Map4-1.png";
import map8 from "../assets/images/Map4-2.png";
import map9 from "../assets/images/Map5-1.png";
import map10 from "../assets/images/Map5-2.png";
import { ImageWithTitle } from '../components/ImageWithTitle';

function Settings() {
    let navigate = useNavigate();

    const [mapNames, setMapNames] = useState(["", "", "", "", ""]);

    useEffect(() => {
        const fetchMaps = async () => {
            const res = await fetch(env.BACKEND_URL + "/users/maps", {
                method: "GET",
            });

            if (res.ok) {
                const data = await res.json();

                var names = ["", "", "", "", ""];

                for (let i = 0; i < data.length; i++) {
                    names[data[i].difficulty - 1] = data[i].map_name;
                }

                setMapNames(names);
            }
        }

        fetchMaps();
    }, [])


    function changeMapDiff1(event) {
        setMapNames([event.target.value, mapNames[1], mapNames[2], mapNames[3], mapNames[4]]);
    }

    function changeMapDiff2(event) {
        setMapNames([mapNames[0], event.target.value, mapNames[2], mapNames[3], mapNames[4]]);
    }

    function changeMapDiff3(event) {
        setMapNames([mapNames[0], mapNames[1], event.target.value, mapNames[3], mapNames[4]]);
    }

    function changeMapDiff4(event) {
        setMapNames([mapNames[0], mapNames[1], mapNames[2], event.target.value, mapNames[4]]);
    }

    function changeMapDiff5(event) {
        setMapNames([mapNames[0], mapNames[1], mapNames[2], mapNames[3], event.target.value]);
    }

    async function Save() {
        const res = await fetch(env.BACKEND_URL + "/admin/set-maps", {
            method: "PUT",
            credentials: "include",
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({ maps: mapNames })
        });

        if (res.ok)
            alert(await res.text())
    }


    return (
        <div>
            <Header navigate={navigate}></Header>
            
            <div className="settings">

                <div className="settings-title">
                    Repère spatial
                </div>

                <div className="setting">
                    <label className="setting-label">Carte pour la difficulté 1 : </label>
                    <select className="setting-label" id="diff-1-select" onChange={changeMapDiff1} value={mapNames[0]}>
                        <option value="Map 1">Map 1</option>
                        <option value="Map 2">Map 2</option>
                    </select>

                    <ImageWithTitle title="Map 1" image={map1} />
                    <ImageWithTitle title="Map 2" image={map2} />
                </div>

                <div className="setting">
                    <label className="setting-label">Carte pour la difficulté 2 : </label>
                    <select className="setting-label" id="diff-2-select" onChange={changeMapDiff2} value={mapNames[1]}>
                        <option value="Map 3">Map 3</option>
                        <option value="Map 4">Map 4</option>
                    </select>

                    <ImageWithTitle title="Map 3" image={map3} />
                    <ImageWithTitle title="Map 4" image={map4} />
                </div>

                <div className="setting">
                    <label className="setting-label">Carte pour la difficulté 3 : </label>
                    <select className="setting-label" id="diff-3-select" onChange={changeMapDiff3} value={mapNames[2]}>
                        <option value="Map 5">Map 5</option>
                        <option value="Map 6">Map 6</option>
                    </select>

                    <ImageWithTitle title="Map 5" image={map5} />
                    <ImageWithTitle title="Map 6" image={map6} />
                </div>

                <div className="setting">
                    <label className="setting-label">Carte pour la difficulté 4 : </label>
                    <select className="setting-label" id="diff-4-select" onChange={changeMapDiff4} value={mapNames[3]}>
                        <option value="Map 7">Map 7</option>
                        <option value="Map 8">Map 8</option>
                    </select>

                    <ImageWithTitle title="Map 7" image={map7} />
                    <ImageWithTitle title="Map 8" image={map8} />
                </div>

                <div className="setting">
                    <label className="setting-label">Carte pour la difficulté 5 : </label>
                    <select className="setting-label" id="diff-5-select" onChange={changeMapDiff5} value={mapNames[4]}>
                        <option value="Map 9">Map 9</option>
                        <option value="Map 10">Map 10</option>
                    </select>

                    <ImageWithTitle title="Map 9" image={map9} />
                    <ImageWithTitle title="Map 10" image={map10} />
                </div>

                <div>
                    <button className="button" onClick={Save}>Sauvegarder</button>
                </div>
            </div>
        </div>
    );
}

export default Settings;